import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { MainContent } from "./MainContent/MainContent";
import { SiderData } from "./SiderData/SiderData";
import { Features } from "./Features/Features";
import { MemorableAirportExepreincePageHeading } from "./MemorableAirportExepreincePageHeading";


export const MemorableAirportExperiences = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING"
  ) => {
    const payload = {
      action: action,
      method: method,
      module: "Business-oppurtunities",
      subModule: query?.get("activeTab"),
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Sustainability_Memorable Airport Experiences",
      payload: {
        id: data?.id,
        ...data,
        published: true,
      },
      status: status,
    };

    console.log("payload", payload.payload);
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };
  const items = [
    {
      label: "Main Content",
      key: "MainContent",
      children: <MainContent/>
    },
    {
      label: "Sider Data",
      key: "SiderData",
      children: <SiderData/>
    },
    {
      label:"Features",
      key: "Features",
      children: <Features/>
    },
    {
      label:"Page Heading",
      key: "memorableAirportExperiencesPageHeading",
      children: <MemorableAirportExepreincePageHeading/>
    }
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
